import { useState, useEffect } from "react";

import "./index.css";
import "./header.css";
import { Link } from "react-router-dom";
  
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 700 && menuOpen) setMenuOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);
  return (  
   
  <header>
  <div className="headerName">
    <Link to="/">
    <h1>bugs_love</h1>
    </Link>
  </div>

  <button
    className={`hamburger ${menuOpen ? 'open' : ''}`}
    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
    aria-controls="primary-navigation"
    aria-expanded={menuOpen}
    onClick={() => setMenuOpen(o => !o)}
  >
    <span className="bar" />
    <span className="bar" />
    <span className="bar" />
  </button>

  <nav id="primary-navigation" className={`headerMenu ${menuOpen ? 'open' : ''}`} role="navigation">
    <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
    <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
    <Link to="/vbr" onClick={() => setMenuOpen(false)}>VBR</Link>
    <Link to="/discography" onClick={() => setMenuOpen(false)}>Discography</Link>
    <Link to="/order" onClick={() => setMenuOpen(false)}>Order</Link>
    <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
  </nav>
    
</header>
);
}

export default Header;